import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=f5f2dd84&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=f5f2dd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f2dd84",
  null
  
)

export default component.exports